import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import { pushToast, removeToast } from 'containers/ToastManager/actions';
import { compose } from 'redux';
import { useParams, useHistory } from 'react-router-dom';

import { FullScreenDialog, List, Tab, Tabs, TabList, TabPanel } from '@pearsontechnology/aero-components';

import { dispatch as storeDispatch } from 'pluginServices/store';
import { clear as clearSelectionState } from 'pluginServices/selectionState/actionCreators';
import { setSelectedProject, deleteIngestionRecord } from 'Workspace/Projects/store/actions';
import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import Sidebar from 'Workspace/components/WorkspaceSidebar';
import HomeNavigation from 'Workspace/components/HomeNavigation';
import HelpMenu from 'Workspace/components/WorkspaceHelpMenu';
import DuplicateCoursewareModal from 'Workspace/components/DuplicateCoursewareModal';
import Link from 'data/Link';
import { getPluginSchema as getPluginSchemaAction } from 'data/Plugin/actions';
import activityServiceShape from 'services/types/activityService';
import pathwayServiceShape from 'services/types/pathwayService';
import projectServiceShape from 'services/types/projectService';
import enhanceWithServices from 'hocs/enhanceWithServices';
import workspaceService from 'services/WorkspaceService';
import DialogPortal from 'components/DialogPortal';
import PlaceholderList from 'components/PlaceholderList';
import PluginSelectionModal from 'components/PluginSelectionModal';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { commandWorkspaceProjectIngestGet } from 'containers/ConnectionManager/actions';
import {
  PageWrapper, PageViewport, PageActions, PageActionsRight, PageActionsLeft, PageContent,
} from 'components/PageStyles';
import { selectCurrentMe } from 'data/CurrentUser/selectors';
import meShape from 'Workspace/types/me';
import helpContext from 'constants/helpContext';
import { ActionTypes, PermissionTypes } from 'constants/enums';
import authenticationTypes from 'constants/authenticationTypes';
import { MAX_FAVORITES_LIMIT } from 'constants/favoritesLimit';
import gtmService from 'utils/gtm/gtmService';
import { GTM_EVENT_TYPES, GTM_EVENT_CATEGORY, GTM_EVENT_ACTION } from 'utils/gtm/constants';
import { gtmTrackAuthoringCourseContentUserInteraction } from 'utils/gtm/handler';
import ImportModal from 'components/Import/ImportModal';
import { featureKeys } from 'services/FeatureFlagService';
import { selectWorkspacesLoadingState, selectWorkspace } from 'Workspace/Admin/store/selectors';
import { STATUS } from 'components/Import/ImportList/constants';

import messages from './messages';
import ProjectActivityList from '../ProjectActivityList';
import ProjectPublicationDetails from '../ProjectPublicationDetails';
import AddProjectContent from '../AddProjectContent';
import ProjectAvatarStack from '../ProjectAvatarStack';
import ProjectActions from '../ProjectActions';
import DeleteConfirm from '../DeleteConfirm';
import FavoritesLimitModal from '../FavoritesLimitModal';
import ImportHistoryTab from '../ImportHistoryTab';

import MoveProjectModal from '../MoveProjectModal';
import { ActionsRightWrapper, ProjectActionsWrapper, TabPanels, PlaceholderListItem, PlaceholderText, PlaceholderListItemColumn } from './styles';
import ProjectTitle from '../ProjectTitle';
import ProjectSettings from '../ProjectSettings';
import { ICON_LIBRARY_LIST } from 'containers/IconLibraryManager/IconLibrarySelector/constants';
import { createCornucopiaScreen } from 'builder/Pathway/components/ScreenEditor/Cornucopia/helpers';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';
import { PUBLICATION_STATUS } from 'constants/constants';
import { getIngestionList } from '../../store/selectors';
import { toastTypes } from 'components/Toast';
import GuardRailsSelectorModal from "Workspace/components/GuardRailsSelectorModal";
import GuardRailsService from 'services/GuardRailsService';
import pluginTypes from 'constants/pluginTypes';
import { stripTags } from 'Workspace/Publications/utils';
import { invalidAuthorNames } from 'Workspace/Publications/utils/constants';

const { OWNER } = PermissionTypes;
const DUPLICATION_TOAST_ID = 'duplication-in-progress';

const ProjectPage = ({
  activityService,
  pathwayService,
  projectService,
  favoritesService,
  getPluginSchemaPromise,
  goToActivity,
  goToProjects,
  currentUser,
  dispatchCommandProjectIngestGet,
  workspacesLoading,
  selectedWorkspace = workspaceService.getSelectedWorkspace(),
  dispatchDeleteIngestionRecord,
  annotationService,
  getFeatureFlagValue,
  ingestionList,
}) => {
  const isProjectsSettingsEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_PROJECTS_SETTINGS) && currentUser?.authenticationType === authenticationTypes.IES_V2;
  const isWorkspaceImportEpubEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_IMPORT_EPUB);
  const isCornucopiaPhaseOneEnabled = getFeatureFlagValue(featureKeys.CORNUCOPIA_PHASE_ONE);
  const isWorkspaceRedesignFFEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_REDESIGN);
  const isPublicationDetailTabEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_PROJECTS_PUBLICATION_DETAILS_TAB);
  const isBRNT18710WSRedesignFFEnabled = getFeatureFlagValue(featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22);
  const isImportPillOnProjectListEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_IMPORTPILL_ONPROJECTLIST);
  const isSlateJSGuardrailEnabled = getFeatureFlagValue(featureKeys.BVEW_1232_Slate_JS_Guardrail);
  const isWorkspaceRedesignEnabled = isWorkspaceRedesignFFEnabled || isBRNT18710WSRedesignFFEnabled;
  const isOculusStatusEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_ACTIVITY_LIST_OCULUS_STATUS);
  const isAuthoringGuardRailsEnabled = GuardRailsService.isGuardRailsEnabled();
  const [isImportEpubEnabled, setIsImportEpubEnabled] = useState(false);
  const [isTabEnabled, setIsTabEnabled] = useState(false);
  const [favoritesLength, setFavoritesLength] = useState(0);
  const [isFavoritesLimitModalVisible, setFavoritesLimitModalVisible] = useState(false);
  const [modalPluginType, setModalPluginType] = useState();
  const [showModal, setShowModal] = useState(false);
  const isComponentMounted = useRef(false);
  const [modalConfig, setModalConfig] = useState();
  const [loading, setLoading] = useState(true);
  const [activityList, setActivityList] = useState([]);
  const [exportedActivityList, setExportedActivityList] = useState([]);
  const [project, setProject] = useState({});
  const [isImportModalVisible, setImportModalVisible] = useState(false);
  const [isMoveProjectModalVisible, setMoveProjectModalVisible] = useState(false);
  const [isDeleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [isDuplicateCoursewareModalVisible, setDuplicateCoursewareModalVisible] = useState(false);
  const [projectSettings, setProjectSettings] = useState({});
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [isDuplicationComplete, setIsDuplicationComplete] = useState(true);
  const [duplicateAsBronteViewer, setDuplicateAsBronteViewer] = useState(false);
  const [activitiesCurrentlyIngesting, setActivitiesCurrentlyIngesting] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState('');
  const { projectId } = useParams();
  const history = useHistory();
  const links = [new Link('/courseware', 'Courseware')];

  const INGESTION_STATUS_DELETED = 'DELETED';
  const INGESTION_STATUS_COMPLETED = 'COMPLETED';

  useEffect(() => {
    isComponentMounted.current = true;
    if (location) {
      const { pathname } = location;
      gtmService.gtmTrackEvent({ eventType: GTM_EVENT_TYPES.PAGEVIEW, payload: { pageName: pathname } });
    }
    return () => {
      isComponentMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (project && !workspacesLoading) {
      workspaceService.updateWorkspace(project.workspaceId);
    }
  }, [project, workspacesLoading]);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  async function getProject() {
    const projectDetails = await projectService.getProject(projectId);
    setProject(projectDetails);
    setProjectSettings(projectDetails.config ? JSON.parse(projectDetails.config) : {});

    storeDispatch(setSelectedProject(projectDetails));

    setIsImportEpubEnabled(isWorkspaceImportEpubEnabled && (projectDetails?.permissionLevel === OWNER));
    // TODO: Move this action to somewhere that makes more sense
    storeDispatch(clearSelectionState());
  }

  async function getUserFavouriteList() {
    const accountId = currentUser?.accountId;
    return await favoritesService.getFavouriteActivityList(accountId);
  }

  async function identifyFavouriteItem(projectActivityList) {

    const favouriteActivityList = await getUserFavouriteList();
    const userFavoritesLength = favouriteActivityList?.favorites?.length || 0;
    setFavoritesLength(userFavoritesLength);

    projectActivityList.forEach((activity) => {

      const favouriteActivity = favouriteActivityList?.favorites?.find((favourite) =>
        favourite.activityId === activity.activityId || favourite.rootElementId === activity.activityId
      );
      if (favouriteActivity) {
        activity.isFavourite = true;
        activity.rootElementId = favouriteActivity.rootElementId;
        activity.favoriteId = favouriteActivity.id;
      } else {
        activity.isFavourite = false;
      }
    });
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  async function getProjectActivityList() {
    const projectActivityList = await projectService.getProjectActivityList(projectId, ['title'], isOculusStatusEnabled);
    projectActivityList.sort((a, b) =>
      new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt));

    if (isWorkspaceRedesignEnabled && currentUser?.accountId) {
      await identifyFavouriteItem(projectActivityList);
    }
    setActivityList(projectActivityList);
    if (isPublicationDetailTabEnabled) {
      // Update logic until BACW-747 comes in.
      const exportedActivities = projectActivityList.filter((activity) => {
        const publicationDetails = Array.isArray(activity.publicationDetails) ? activity.publicationDetails : [];
        return publicationDetails.some((pub) =>
          pub.oculusStatus === PUBLICATION_STATUS.IN_REVIEW || pub.oculusStatus === PUBLICATION_STATUS.PUBLISHED_LIVE
        );
      });
      setExportedActivityList(exportedActivities);
    }
  }
  useEffect(() => {
    if (loading && isDuplicationComplete) {
      getProject()
        .then(getProjectActivityList)
        .catch(goToProjects)
        .finally(() => setLoading(false));
    }
  }, [loading, isDuplicationComplete, projectId, projectService, goToProjects, isWorkspaceImportEpubEnabled, currentUser, isWorkspaceRedesignEnabled, getProject, getProjectActivityList]);

  useEffect(() => {
    if (isImportEpubEnabled) {
      projectService.workspaceProjectSubscribe(projectId, (broadcast) => {
        const { ingestionId, ingestionStatus } = broadcast.response;
        if (ingestionId) {
          /*
           * Everytime we receive the broadcast message, we make a call to
           * project.ingest.get and update our store.
           */
          if (ingestionStatus === INGESTION_STATUS_DELETED) {
            dispatchDeleteIngestionRecord(ingestionId);
          } else {
            dispatchCommandProjectIngestGet(ingestionId);
          }

          if (ingestionStatus === INGESTION_STATUS_COMPLETED) {
            getProject().then(getProjectActivityList);
          }
        }
      });
    }
    setIsTabEnabled(isProjectsSettingsEnabled || isImportEpubEnabled || isPublicationDetailTabEnabled);
    return () => {
      if (isImportEpubEnabled) {
        projectService.workspaceProjectUnsubscribe(projectId);
      }
    };
  }, [dispatchDeleteIngestionRecord, dispatchCommandProjectIngestGet, isImportEpubEnabled, projectId, projectService, isProjectsSettingsEnabled, loading, isPublicationDetailTabEnabled, getProject, getProjectActivityList]);

  useEffect(() => {
    // CHECKING: Does any item in the activityList currently have an ingestion happening within the ingestionList?
    // If so, we want to show a pill on the activityList item that says "Ingesting"
    if (isImportPillOnProjectListEnabled && ingestionList && activityList) {
      const updatedIngestionIds = [];
      ingestionList.forEach((ingestionItem) => {
        activityList.forEach((activityItem) => {
          if (ingestionItem.courseName === activityItem.configFields.title && ingestionItem.status === STATUS.IMPORTING.text) {
            updatedIngestionIds.push(activityItem.activityId);
          }
        });
      });
      setActivitiesCurrentlyIngesting(updatedIngestionIds);
    }
  }, [ingestionList, activityList, isImportPillOnProjectListEnabled]);

  const onOpenModal = async (type) => {
    if (type === 'import') {
      setImportModalVisible(true);
    } else if (type === 'eText') {
      const cornucopiaScreenPath = await createCornucopiaScreen(projectId);
      history.push(cornucopiaScreenPath);
    }  else  {
      setModalPluginType(type);
      setShowModal(true);
      
      setModalConfig(PluginSelectionModal.getConfig(type));
    }
  };

  const onCloseModal = () => {
    if (isComponentMounted.current) {
      setShowModal(false);
      setModalConfig(undefined);
      setSelectedCourseType('');
    }
  };

  const onSelectOther = () => {
    setSelectedCourseType(pluginTypes.OTHER);
    setModalPluginType(pluginTypes.COURSE);
    setModalConfig(PluginSelectionModal.getConfig(pluginTypes.COURSE));
  };

  const handlePluginSelected = async ({ title, description, pluginId, version, pluginType, pathwayTypes }) => {
    const pluginSchema = await getPluginSchemaPromise(pluginId, version);

    const newActivityConfig = { title, description };

    const activityId = await activityService.createProjectActivity(
      pluginId, version, pluginSchema, newActivityConfig, projectId
    );

    //Associate Default IconLibraryList with the given activity
    await activityService.authorActivityIconLibraryAssociate({
      activityId,
      iconLibraries: ICON_LIBRARY_LIST,
    });

    if (pathwayTypes) {
      // A course was selected, create pathways
      await Promise.all(pathwayTypes.map((pathwayType) => pathwayService.createPathway(activityId, pathwayType.key, pathwayType.value, pluginSchema[pathwayType.key[0]]?.preload)));
    }

    await goToActivity(pluginType, activityId);
  };

  const handleTemplateSelected = async ({ templateId, title }) => {
    const activityId = await projectService.projectActivityDuplicate(projectId, templateId);
    if (title) {
      await activityService.saveInActivityConfig(activityId, ['title'], title);
    }

    const { type: pluginType } = await activityService.getInActivity(
      activityId,
      activityService.keyPaths.pluginRef
    );

    await goToActivity(pluginType, activityId);
  };

  const openMoveProjectModal = () => {
    setMoveProjectModalVisible(true);
  };

  const closeMoveProjectModal = () => {
    setMoveProjectModalVisible(false);
  };

  const openDeleteConfirm = () => {
    setDeleteConfirmVisible(true);
  };

  const closeDeleteConfirm = () => {
    setDeleteConfirmVisible(false);
  };

  const closeFavoritesLimitModal = () => {
    setFavoritesLimitModalVisible(false);
  };

  const closeImportModal = () => {
    setImportModalVisible(false);
  };

  const [selectedActivityId, setSelectedActivity] = useState();
  const openDuplicateCoursewareModal = (activityId) => {
    setSelectedActivity(activityId);
    setDuplicateCoursewareModalVisible(true);
  };

  const closeDuplicateCoursewareModal = () => {
    setDuplicateCoursewareModalVisible(false);
  };

  const handleMoveProject = async (workspaceId) => {
    await projectService.moveProject(projectId, workspaceId);
    closeMoveProjectModal();
    goToProjects();
  };

  const handleDeleteProject = async () => {
    await projectService.deleteProject(projectId);
    closeDeleteConfirm();
    goToProjects();
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!isDuplicationComplete) {
        e.preventDefault();
      }
    };
    const handleKeyDown = (e) => {
      if (!isDuplicationComplete && e.ctrlKey && e.key === 'r') {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isDuplicationComplete]);

  const handleDuplicateCourseware = async (targetProjectId) => {
    setIsDuplicationComplete(false);
    setLoading(true);
    
    storeDispatch(pushToast({
      type: toastTypes.STICKY,
      toastId: DUPLICATION_TOAST_ID,
      message: intl.formatMessage(messages.duplicateInProgress),
      waitForAction: true,
      actions: [{ text: 'DISMISS', fn: () => {} }],
    }));

    try {
      if (duplicateAsBronteViewer) {
        await projectService.projectActivityMigrate(project.workspaceId, targetProjectId, selectedActivityId);
        storeDispatch(pushToast({ message: intl.formatMessage(messages.duplicateToBVStarted) }));
        setDuplicateAsBronteViewer(false);
      } else {
        const newActivityId = await projectService.projectActivityDuplicate(targetProjectId, selectedActivityId);
        await activityService.updateDuplicatedActivityTitle(newActivityId);
      }
    } catch (error) {
      storeDispatch(pushToast({ message: intl.formatMessage(messages.duplicateFailed) }));
    } finally {
      storeDispatch(removeToast({ toastId: DUPLICATION_TOAST_ID }));
      closeDuplicateCoursewareModal();
      setIsDuplicationComplete(true);
    }
  };

  const handleActionMenuItemClick = (actionType) => {
    switch (actionType) {
      case ActionTypes.MOVE:
        openMoveProjectModal();
        break;
      case ActionTypes.DELETE:
        openDeleteConfirm();
        break;
      default:
    }
  };

  const saveSettings = async (index, setting) => {
    const updatedSettings = { ...projectSettings };
    if (!updatedSettings.assets) {
      updatedSettings.assets = [];
    }
    updatedSettings.assets[index] = { ...setting };
    setProjectSettings(updatedSettings);
    await projectService.updateProjectConfig(project.id, project.name, JSON.stringify(updatedSettings));
  };

  const removeWorkspaceActivity = async (activityId) => {
    const response = await projectService.projectActivityDelete(projectId, activityId);

    if (response) {
      setActivityList(activityList.filter((activity) => activity.activityId !== activityId));
    }
  };

  const handleTranslateActivity = async (activityId, targetLanguage) => {
    setIsDuplicationComplete(false);
    setLoading(true);

    storeDispatch(pushToast({
      type: toastTypes.STICKY,
      toastId: DUPLICATION_TOAST_ID,
      message: intl.formatMessage(messages.duplicateInProgress),
      waitForAction: true,
      actions: [{ text: 'DISMISS', fn: () => {} }],
    }));

    try {
      await projectService.projectActivityDuplicate(projectId, activityId, targetLanguage);
    } catch (error) {
      storeDispatch(pushToast({ message: intl.formatMessage(messages.duplicateFailed) }));
    } finally {
      storeDispatch(removeToast({ toastId: DUPLICATION_TOAST_ID }));
      setIsDuplicationComplete(true);
    }
  };

  const handleDuplicateBvClick = async (activityId) => {
    try {
      const { config } = await activityService.getActivity(activityId);
      const authorName = stripTags(config?.author || '').trim();
      if (!authorName || invalidAuthorNames.includes(authorName.toLowerCase())) {
        storeDispatch(pushToast({ message: intl.formatMessage(messages.authorNameRequired) }));
        return;
      }
      setDuplicateAsBronteViewer(true);
      openDuplicateCoursewareModal(activityId);
    } catch (error) {
      storeDispatch(pushToast({ message: intl.formatMessage(messages.duplicateFailed) }));
    }
  };

  const handleActivityListAction = (type, activity, targetLanguage) => {
    switch (type) {
      case ActionTypes.DELETE:
        removeWorkspaceActivity(activity.activityId);
        break;
      case ActionTypes.DUPLICATE:
      case ActionTypes.DUPLICATE_EPUB:
        openDuplicateCoursewareModal(activity.activityId);
        break;
      case ActionTypes.DUPLICATE_BV:
        handleDuplicateBvClick(activity.activityId);
        break;
      case ActionTypes.TRANSLATE:
        handleTranslateActivity(activity.activityId, targetLanguage);
        break;
      default:
        break;
    }
  };

  const handleToggleFavourite = async (activity) => {
    if (activity.isFavourite) {
      await handleRemoveFavorite(activity);
      return;
    }

    await handleCreateFavourite(activity);
  };

  const handleRemoveFavorite = async (activity) => {
    const { accountId } = currentUser;
    const { favoriteId, activityId, rootElementId } = activity;
    const response = await favoritesService.removeFavorites(accountId, favoriteId, rootElementId);
    if (response) {
      const activityListUpdated = activityList.map(
        (activity) => {
          if (activity.activityId === activityId) {
            activity.isFavourite = false;
            setFavoritesLength(favoritesLength - 1);
          }
          return activity;
        }
      );
      setActivityList(activityListUpdated);
    }
  };

  const handleCreateFavourite = async (activity) => {
    const { accountId } = currentUser;
    const { activityId } = activity;
    const { type } = activity?.plugin;
    const { id: projectId, workspaceId } = project;

    if (!accountId || !activityId || !type || !projectId || !workspaceId) {
      return;
    }

    if (favoritesLength >= MAX_FAVORITES_LIMIT) {
      setFavoritesLimitModalVisible(true);
      return;
    }

    const response = await favoritesService.addFavourites(accountId, activityId, type, projectId, workspaceId);
    if (response) {
      const activityListUpdated = activityList.map(
        (activity) => {
          if (activity.activityId === activityId) {
            activity.isFavourite = true;
            activity.rootElementId = activityId;
            activity.favoriteId = response.favoriteId;
            setFavoritesLength(favoritesLength + 1);
          }
          return activity;
        }
      );
      setActivityList(activityListUpdated);
    }
  };

  const handleTitleChange = (title) => {
    setProject({ ...project, name: title });
  };
  /**
    * We would need to use selectedIndex in Tabs to check which tab the user currently is in,
    * so we have mapped all the tab and tabPanel and passed selectTab property to the tabs. Also in
    * future if new tabs are introduced we can place it in the tabData array.
  */
  const getProjectContentPage = () =>
    (!loading && activityList?.length > 0 ? (
      <ProjectActivityList
        projectId={projectId}
        activityList={activityList}
        activitiesCurrentlyIngesting={activitiesCurrentlyIngesting}
        currentUser={currentUser}
        onAction={handleActivityListAction}
        toggleFavourite={handleToggleFavourite}
        annotationService={annotationService}
      />
    ) : (
      <List>
        <PlaceholderList />
      </List>
    )
    );

  const getProjectPublicationDetailsPage = () =>
    (!loading && exportedActivityList.length > 0 ? (
      <ProjectPublicationDetails
        activityList={exportedActivityList}
      />
    ) : (
      <List>
        <PlaceholderListItem compact>
          <PlaceholderListItemColumn colWidth="100%">
            <PlaceholderText>{intl.formatMessage(messages.projectPageNoPublicationsFound)}</PlaceholderText>
          </PlaceholderListItemColumn>
        </PlaceholderListItem>
      </List>
    )
    );

  const getProjectSettingsPage = () => (
    <ProjectSettings settings={projectSettings} saveSettings={saveSettings} />
  );

  const getImportHistoryPage = () => (
    <ImportHistoryTab setImportModalVisible={setImportModalVisible} projectId={projectId} selectedIndex={selectedTabIndex} />
  );

  const tabData = [
    {
      tabId: 'all-content',
      tabEnabled: true,
      tabHeader: intl.formatMessage(messages.projectPageAllContent),
      tabPanelContent: getProjectContentPage(),
    },
    {
      tabId: 'settings',
      tabEnabled: isProjectsSettingsEnabled,
      tabHeader: intl.formatMessage(messages.projectPageSettings),
      tabPanelContent: getProjectSettingsPage(),
    },
    {
      tabId: 'import-history',
      tabEnabled: isImportEpubEnabled,
      tabHeader: intl.formatMessage(messages.projectPageImportHistory),
      tabPanelContent: getImportHistoryPage(),
    },
    {
      tabId: 'publication-details',
      tabEnabled: isPublicationDetailTabEnabled,
      tabHeader: intl.formatMessage(messages.projectPagePublicationDetail),
      tabPanelContent: getProjectPublicationDetailsPage(),
    },
  ];

  const enabledTabData = tabData.filter((item) => item.tabEnabled);
  const selectImportHistoryTab = () => {
    const importHistoryIndex = enabledTabData.findIndex(
      (item) => item.tabId === 'import-history'
    );
    setSelectedTabIndex(importHistoryIndex);
  };
  const selectTabHandler = (index) => {
    const selectedTab = enabledTabData[index];
    
    if (selectedTab?.tabId === 'import-history') {
      // Event ID 5 — Navigate to Content Import History
      gtmTrackAuthoringCourseContentUserInteraction({
        eventCategory: GTM_EVENT_CATEGORY.COURSE_PROJECT_DASHBOARD,
        eventAction: GTM_EVENT_ACTION.CLICK_NAVIGATE_TO_CONTENT_IMPORT_HISTORY,
        locationInApp: `Select a Project in Courseware > Click on ${selectedTab.tabHeader} tab`,
      });
    }

    if (selectedTab?.tabId === 'publication-details') {
      // Event ID 7 — Navigate to Publication Details
      gtmTrackAuthoringCourseContentUserInteraction({
        eventCategory: GTM_EVENT_CATEGORY.COURSE_PROJECT_DASHBOARD,
        eventAction: GTM_EVENT_ACTION.CLICK_NAVIGATE_TO_PUBLICATION_DETAILS,
        locationInApp: `Select a Project in Courseware > Click on ${selectedTab.tabHeader} tab`,
      });
    }
    setSelectedTabIndex(index);
  };

  return (
    <PageWrapper>
      <Sidebar navigation={<HomeNavigation selectedKey="courseware" />} />
      <PageViewport>
        <WorkspaceHeader links={links} title={project?.name} />
        <PageActions>
          <PageActionsLeft>
            <ProjectTitle
              projectId={projectId}
              title={project?.name}
              onTitleChange={handleTitleChange}
              permissionLevel={project?.permissionLevel}
            />
          </PageActionsLeft>
          <PageActionsRight>
            <ActionsRightWrapper>
              <ProjectAvatarStack projectId={projectId} />
              <ProjectActionsWrapper>
                <ProjectActions permissionLevel={project?.permissionLevel} projectId={projectId} onActionsMenuItemClick={handleActionMenuItemClick} />
              </ProjectActionsWrapper>
              <AddProjectContent
                openModalSelector={onOpenModal}
                isImportEpubEnabled={isImportEpubEnabled}
                isCornucopiaPhaseOneEnabled={isCornucopiaPhaseOneEnabled}
              />
            </ActionsRightWrapper>
          </PageActionsRight>
        </PageActions>
        <PageContent>
          {!isTabEnabled && !loading && activityList.length > 0 && (
            <ProjectActivityList
              projectId={projectId}
              activityList={activityList}
              activitiesCurrentlyIngesting={activitiesCurrentlyIngesting}
              currentUser={currentUser}
              onAction={handleActivityListAction}
              toggleFavourite={handleToggleFavourite}
              annotationService={annotationService}
            />
          )}
          {!isTabEnabled && loading && (
            <List>
              <PlaceholderList />
            </List>
          )}
          {isTabEnabled && (
            <Tabs selectedIndex={selectedTabIndex} selectTab={selectTabHandler}>
              <TabList >
                {enabledTabData.map((item) => <Tab key={item.tabHeader} >{item.tabHeader}</Tab>)}
              </TabList>
              <TabPanels>
                {enabledTabData.map((item) => <TabPanel key={item.tabHeader} >{item.tabPanelContent}</TabPanel>)}
              </TabPanels>
            </Tabs>
          )}
        </PageContent>
      </PageViewport>
      {
        isAuthoringGuardRailsEnabled && showModal && modalPluginType === pluginTypes.COURSE &&
        <DialogPortal>
          <FullScreenDialog onClose={onCloseModal}>
            <GuardRailsSelectorModal projectId={projectId} onClose={onCloseModal} onSelectOther={onSelectOther} goToActivity={goToActivity} isSlateJSGuardrailEnabled={isSlateJSGuardrailEnabled} />
          </FullScreenDialog>
        </DialogPortal>
      }

      {
        showModal && (!isAuthoringGuardRailsEnabled || selectedCourseType === pluginTypes.OTHER || modalPluginType !== pluginTypes.COURSE)  && modalConfig &&
        <DialogPortal>
          <FullScreenDialog onClose={onCloseModal}>
            <PluginSelectionModal
              config={modalConfig}
              pluginType={modalPluginType}
              onClose={onCloseModal}
              onPluginSelect={handlePluginSelected}
              onTemplateSelect={handleTemplateSelected}
            />
          </FullScreenDialog>
        </DialogPortal>
      }
      <MoveProjectModal visible={isMoveProjectModalVisible} onDismiss={closeMoveProjectModal} handleMoveProject={handleMoveProject} />
      <DeleteConfirm visible={isDeleteConfirmVisible} onDismiss={closeDeleteConfirm} handleDeleteProject={handleDeleteProject} />
      <DuplicateCoursewareModal
        visible={isDuplicateCoursewareModalVisible}
        onDismiss={closeDuplicateCoursewareModal}
        handleDuplicateCourseware={handleDuplicateCourseware}
        selectedActivityId={selectedActivityId}
        initialSelectedWorkspace={selectedWorkspace}
      />
      {isFavoritesLimitModalVisible &&
        <FavoritesLimitModal
          visible={isFavoritesLimitModalVisible}
          onDismiss={closeFavoritesLimitModal}
        />
      }
      {isImportModalVisible &&
        <ImportModal
          projectId={projectId}
          visible={isImportModalVisible}
          onDismiss={closeImportModal}
          selectImportHistoryTab={selectImportHistoryTab}
        />
      }
      <HelpMenu helpContext={helpContext.OPEN_PROJECT} />
    </PageWrapper>
  );
};

ProjectPage.propTypes = {
  goToActivity: PropTypes.func,
  goToProjects: PropTypes.func,
  getPluginSchemaPromise: PropTypes.func,
  activityService: activityServiceShape,
  pathwayService: pathwayServiceShape,
  projectService: projectServiceShape,
  currentUser: meShape,
  dispatchCommandProjectIngestGet: PropTypes.func,
  workspacesLoading: PropTypes.bool,
  dispatchDeleteIngestionRecord: PropTypes.func,
  ingestionList: PropTypes.array,
};

const mapStateToPros = (state) => ({
  currentUser: selectCurrentMe(state),
  workspacesLoading: selectWorkspacesLoadingState(state),
  selectedWorkspace: selectWorkspace(state),
  ingestionList: getIngestionList(state),
});

const mapDispatchToProps = (dispatch) => ({
  goToProjects: () => {
    dispatch(push('/courseware'));
  },
  goToActivity: (pluginType, activityId) => {
    dispatch(push(`/${pluginType}/${activityId}`));
  },
  getPluginSchemaPromise: (pluginId, version) => (
    new Promise((resolve /* , reject */) => {
      const schemaCallback = (pluginSchema) => resolve(pluginSchema);
      dispatch(getPluginSchemaAction(pluginId, version, schemaCallback));
    })
  ),
  dispatchCommandProjectIngestGet: (ingestionId) => dispatch(commandWorkspaceProjectIngestGet(ingestionId)),
  dispatchDeleteIngestionRecord: (ingestionId) => dispatch(deleteIngestionRecord(ingestionId)),
});

const withConnect = connect(mapStateToPros, mapDispatchToProps);
const flagNames = [
  featureKeys.WORKSPACE_PROJECTS_SETTINGS,
  featureKeys.WORKSPACE_IMPORT_EPUB,
  featureKeys.CORNUCOPIA_PHASE_ONE,
  featureKeys.WORKSPACE_REDESIGN,
  featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22,
  featureKeys.WORKSPACE_PROJECTS_PUBLICATION_DETAILS_TAB,
];

export default compose(withConnect, enhanceWithServices, enhanceWithFeatureFlagSubscription)(ProjectPage, flagNames);
